<template>
  <main>
    <section class="row landing">
      <b-container fluid>
        <b-container>
          <div class="float-right">
            <I18n />
          </div>
          <h1 v-html="$t('meta.DIo')"></h1>
          <b-row
            id="bubbles"
            align-h="between"
            class="hidden-xs text-center mt-5"
          >
            <b-col
              class="bbl"
              md="4"
            >
              <p class="p-3 mt-5 mr-auto ml-0 d-flex">
                <a
                  href="#enjeux"
                  class="align-self-center"
                  @mouseover="explain=true;"
                  @click="explain=true;
                          $scrollTo($event.currentTarget.href.replace(/(.*)(#.*)/, '$2'));"
                  v-html="$t('home.intro.bubble1')"
                ></a>
              </p>
            </b-col>
            <b-col
              class="bbl"
              md="4"
            >
              <p class="p-3 d-flex">
                <a
                  href="#solutions"
                  class="align-self-center"
                  @mouseover="explain=true;"
                  @click="explain=true;
                          $scrollTo($event.currentTarget.href.replace(/(.*)(#.*)/, '$2'));"
                  v-html="$t('home.intro.bubble2')"
                ></a>
              </p>
            </b-col>
            <b-col
              class="bbl"
              md="4"
            >
              <p class="p-3 mt-5 ml-auto mr-0 d-flex">
                <router-link
                  class="align-self-center"
                  :to="`/${$t('lang')}/list`"
                  v-html="$t('home.intro.bubble3')"
                />
              </p>
            </b-col>
          </b-row>
        </b-container>

        <b-container class="ombre choice">
          <b-row class="text-center m-0">
            <b-col
              lg="6"
              class="fb-f7 h3 fc-light m-0 p-3"
            >
              <router-link
                :to="`/${$t('lang')}/list`"
                class="text-decoration-none d-flex flex-column justify-content-between h-100"
              >
                <p class="fc-light">
                  <span v-html="$t('home.intro.btnList1')"></span>
                  <br />
                  <small>
                    <i
                      v-html="$t('home.intro.btnList2')"
                    ></i>
                  </small>
                </p>
                <p
                  class="btn-lg btn-light"
                  v-html="$t('home.intro.btnList3')"
                ></p>
              </router-link>
            </b-col>
            <b-col
              lg="6"
              class="fb-o6 h3 m-0 p-3"
            >
              <router-link
                :to="`/${$t('lang')}/alternatives`"
                class="text-decoration-none d-flex flex-column justify-content-between h-100"
              >
                <p class="fc-light">
                  <span v-html="$t('home.intro.btnAlt1')"></span>
                  <br />
                  <small>
                    <i
                      class="fc-light"
                      v-html="$t('home.intro.btnAlt2')"
                    ></i>
                  </small>
                </p>
                <p
                  class="btn-lg btn-light"
                  v-html="$t('home.intro.btnAlt3')"
                ></p>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </section>

    <section class="row more">
      <b-container class="ombre">
        <h2
          class="mt-4"
          v-html="$t('home.more.title')"
        ></h2>
        <p
          class="accroche"
          v-html="$t('home.more.desc')"
        ></p>

        <b-row>
          <b-col
            md="4"
            class="mt-3"
          >
            <a
              aria-hidden="true"
              class="d-block text-center"
              :href="$t('link.docs')"
            >
              <svg-icon
                :name="$t('svg.docs')"
                size="lg"
                variant="circle fc-o6 fd-o5"
              />
            </a>
            <p v-html="$t('home.more.docs.desc')"></p>
            <p>
              <b-btn
                :href="$t('link.docs')"
                size="sm"
                variant="outline-secondary"
                v-html="$t('home.more.docs.btn')"
              />
            </p>
          </b-col>
          <b-col
            md="4"
            class="mt-3"
          >
            <a
              aria-hidden="true"
              class="d-block text-center"
              :href="$t('link.cloud')"
            >
              <svg-icon
                :name="$t('svg.cloud')"
                size="lg"
                variant="circle fc-v6 fd-v5"
              />
            </a>
            <p v-html="$t('home.more.cloud.desc')"></p>
            <p>
              <b-btn
                :href="$t('link.cloud')"
                size="sm"
                variant="outline-secondary"
                v-html="$t('home.more.cloud.btn')"
              />
            </p>
          </b-col>
          <b-col
            md="4"
            class="mt-3"
          >
            <a
              aria-hidden="true"
              class="d-block text-center"
              :href="$t('link.chatons')"
            >
              <svg-icon
                name="cat"
                size="lg"
                variant="circle fc-j6 fd-j5"
              />
            </a>
            <p v-html="$t('home.more.chatons.desc')"></p>
            <p>
              <b-btn
                :href="$t('link.chatons')"
                size="sm"
                variant="outline-secondary"
                v-html="$t('home.more.chatons.btn')"
              />
            </p>
          </b-col>
        </b-row>

        <h2
          class="mt-4"
          v-html="$t('home.why.title')"
        ></h2>
        <p
          class="accroche"
          v-html="$t('home.why.desc')"
        ></p>

        <b-row>
          <b-col
            md="4"
            class="mt-3"
          >
            <a
              aria-hidden="true"
              class="d-block text-center"
              href="#enjeux"
              @mouseover="explain=true;"
              @click="explain=true;
                      $scrollTo($event.currentTarget.href.replace(/(.*)(#.*)/, '$2'));"
            >
              <svg-icon
                name="user-secret"
                size="lg"
                variant="circle fc-r8 fd-r7"
              />
            </a>
            <p v-html="$t('home.why.explain.desc')"></p>
            <p>
              <b-btn
                href="#enjeux"
                size="sm"
                variant="outline-secondary"
                @mouseover="explain=true;"
                @click="explain=true;
                        $scrollTo($event.currentTarget.href.replace(/(.*)(#.*)/, '$2'));"
                v-html="$t('home.why.explain.btn')"
              />
            </p>
          </b-col>
          <b-col
            md="4"
            class="mt-3"
          >
            <a
              aria-hidden="true"
              class="d-block text-center"
              href="#solutions"
              @mouseover="explain=true;"
              @click="explain=true;
                      $scrollTo($event.currentTarget.href.replace(/(.*)(#.*)/, '$2'));"
            >
              <svg-icon
                name="shield-alt"
                size="lg"
                variant="circle fc-v6 fd-v5"
              />
            </a>
            <p v-html="$t('home.why.props.desc')"></p>
            <p>
              <b-btn
                href="#solutions"
                size="sm"
                variant="outline-secondary"
                @mouseover="explain=true;"
                @click="explain=true;
                        $scrollTo($event.currentTarget.href.replace(/(.*)(#.*)/, '$2'));"
                v-html="$t('home.why.props.btn')"
              />
            </p>
          </b-col>
          <b-col
            md="4"
            class="mt-3"
          >
            <a
              aria-hidden="true"
              class="d-block text-center"
              :href="$t('link.S') + '/association'"
            >
              <svg-icon
                name="r-address-card"
                size="lg"
                variant="circle fc-f7 fd-f6"
              />
            </a>
            <p v-html="$t('home.why.who.desc')"></p>
            <p>
              <b-btn
                :href="`${$t('link.S')}/association`"
                size="sm"
                variant="outline-secondary"
                v-html="$t('home.why.who.btn')"
              />
            </p>
          </b-col>
        </b-row>

        <b-row class="mt-5 mx-n3 bg-light rounded">
          <b-col
            class="pt-3 d-flex flex-column justify-content-between"
            lg="6"
          >
            <div>
              <h2 v-html="$t('home.contact.title')"></h2>
              <p v-html="$t('home.contact.text1')"></p>
              <ul>
                <li
                  v-for="item in $t('home.contact.text2')"
                  :key="item"
                  v-html="item"
                ></li>
              </ul>
              <p v-html="$t('home.contact.text3')"></p>
            </div>
            <p>
              <b-btn
                variant="primary w-50"
                :href="$t('link.contact')"
              >
                <svg-icon
                  name="envelope"
                  size="fw"
                />
                <span v-html="$t('home.contact.btn')"></span>
              </b-btn>
            </p>
          </b-col>
          <b-col
            class="pt-3 d-flex flex-column justify-content-between"
            lg="6"
          >
            <div>
              <h2 v-html="$t('home.support.title')"></h2>
              <p v-html="$t('home.support.text1')"></p>
              <ul>
                <li
                  v-for="item in $t('home.support.text2')"
                  :key="item"
                  v-html="item"
                ></li>
              </ul>
              <p v-html="$t('home.support.text3')"></p>
            </div>
            <p>
              <b-btn
                :href="$t('link.S')"
                variant="soutenir w-50"
              >
                <svg-icon
                  name="heart"
                  size="fw"
                />
                <span v-html="$t('home.support.btn')"></span>
              </b-btn>
            </p>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section
      id="speakabout"
      class="row"
    >
      <b-container class="my-5 text-center">
        <h2 v-html="$t('home.speakabout.title')"></h2>
        <ul class="list-inline">
          <li
            v-for="media in $t('home.medias')"
            :key="media"
            class="list-inline-item fb-0"
          >
            <a :href="media[0]">
              <img
                :alt="media[2]"
                :src="`${$t('baseurl')}img/medias/${media[1]}`"
              />
            </a>
          </li>
        </ul>
        <p>
          <router-link
            class="btn btn-light btn-lg"
            :to="`/${$t('lang')}/medias`"
            v-html="$t('home.speakabout.btn')"
          />
        </p>
      </b-container>
    </section>

    <section
      v-show="explain"
      id="enjeux"
      class="row"
    >
      <b-container class="ombre">
        <b-row>
          <b-col
            lg="8"
            xl="9"
            class="mb-5 mx-auto"
          >
            <h2 v-html="$t('home.explain.stakes.title')"></h2>
            <p v-html="$t('home.explain.stakes.text1')"></p>
            <p v-html="$t('home.explain.stakes.text2')"></p>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            lg="8"
            xl="9"
          >
            <h2 v-html="$t('home.explain.danger.title')"></h2>
            <p v-html="$t('home.explain.danger.text')"></p>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            lg="6"
            class="mt-4"
          >
            <h3 id="t2-espionnum">
              <svg-icon
                :label="$t('home.explain.danger.espionum.title')"
                name="r-eye"
                size="fw"
                variant="fc-g6"
              />
            </h3>
            <p v-html="$t('home.explain.danger.espionum.desc')"></p>

            <img
              alt=""
              class="d-block mx-auto"
              :src="`${$t('baseurl')}img/${$t('lang')}/${$t('img.gee[1]')}`"
            />
          </b-col>
          <b-col
            lg="6"
            class="mt-4"
          >
            <h3 id="t2-privatum">
              <svg-icon
                :label="$t('home.explain.danger.privatum.title')"
                name="r-user-circle"
                size="fw"
                variant="fc-g6"
              />
            </h3>
            <p v-html="$t('home.explain.danger.privatum.desc')"></p>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            lg="6"
            class="mt-4"
          >
            <h3 id="t2-centralisum">
              <svg-icon
                :label="$t('home.explain.danger.centralisum.title')"
                name="r-dot-circle"
                size="fw"
                variant="fc-g6"
              />
            </h3>
            <p v-html="$t('home.explain.danger.centralisum.desc')"></p>
          </b-col>
          <b-col
            lg="6"
            class="mt-4"
          >
            <h3 id="t2-fermetum">
              <svg-icon
                :label="$t('home.explain.danger.fermetum.title')"
                name="lock"
                size="fw"
                variant="fc-g6"
              />
            </h3>
            <p v-html="$t('home.explain.danger.fermetum.desc')"></p>
          </b-col>
        </b-row>

        <img
          alt=""
          class="d-block mx-auto"
          :src="`${$t('baseurl')}img/${$t('lang')}/${$t('img.gee[0]')}`"
        />
      </b-container>
    </section>

    <section
      v-show="explain"
      id="solutions"
      class="row"
    >
      <b-container class="ombre">
        <b-row>
          <b-col
            lg="8"
            xl="9"
          >
            <h2>
              <a id="leds"></a>
              <span v-html="$t('home.explain.props.title')"></span>
            </h2>
            <p v-html="$t('home.explain.props.text')"></p>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            lg="6"
            class="mt-4"
          >
            <h3>
              <svg-icon
                :label="$t('home.explain.props.libre.title')"
                name="lock-open"
                size="fw"
                variant="fc-g6"
              />
            </h3>
            <p v-html="$t('home.explain.props.libre.text1')"></p>
            <p v-html="$t('home.explain.props.libre.text2')"></p>
            <p>
              <strong v-html="$t('home.explain.props.libre.text3')"></strong>
            </p>
          </b-col>
          <b-col
            lg="6"
            class="mt-4"
          >
            <h3>
              <svg-icon
                :label="$t('home.explain.props.ethic.title')"
                name="r-eye-slash"
                size="fw"
                variant="fc-g6"
              />
            </h3>
            <p v-html="$t('home.explain.props.ethic.text1')"></p>
            <p v-html="$t('home.explain.props.ethic.text2')"></p>
            <p>
              <strong v-html="$t('home.explain.props.ethic.text3')"></strong>
            </p>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            lg="6"
            class="mt-4"
          >
            <h3>
              <svg-icon
                :label="$t('home.explain.props.decent.title')"
                name="share-alt"
                size="fw"
                variant="fc-g6"
              />
            </h3>
            <p v-html="$t('home.explain.props.decent.text1')"></p>
            <p v-html="$t('home.explain.props.decent.text2')"></p>
            <p>
              <strong v-html="$t('home.explain.props.decent.text3')"></strong>
            </p>
          </b-col>
          <b-col
            lg="6"
            class="mt-4"
          >
            <h3>
              <svg-icon
                :label="$t('home.explain.props.solid.title')"
                name="people-carry"
                size="fw"
                variant="fc-g6"
              />
            </h3>
            <p v-html="$t('home.explain.props.solid.text1')"></p>
            <p v-html="$t('home.explain.props.solid.text2')"></p>
            <p>
              <strong v-html="$t('home.explain.props.solid.text3')"></strong>
            </p>
          </b-col>
        </b-row>

        <img
          alt=""
          class="d-block mt-5"
          :src="`${$t('baseurl')}img/${$t('lang')}/${$t('img.gee[4]')}`"
        />

        <b-row>
          <b-col
            class="my-5 mx-auto"
            lg="8"
            xl="9"
          >
            <h2 v-html="$t('home.explain.concrete.title')"></h2>
            <p v-html="$t('home.explain.concrete.text1')"></p>
            <p v-html="$t('home.explain.concrete.text2')"></p>
            <p v-html="$t('home.explain.concrete.text3')"></p>
            <p v-html="$t('home.explain.concrete.text4')"></p>
            <p v-html="$t('home.explain.concrete.text5')"></p>
            <p class="text-center">
              <router-link
                class="btn btn-warning btn-lg"
                :to="`/${$t('lang')}/list`"
                v-html="`${$t('list.title')} ${$t('meta.f')}`"
              />
            </p>
          </b-col>
        </b-row>

        <img
          alt=""
          class="d-block"
          :src="`${$t('baseurl')}img/cloud.jpg`"
        />

        <Signature />
      </b-container>
    </section>
  </main>
</template>

<script>
import I18n from 'vue-fs-commons/app/components/partials/I18n.vue';
import Signature from '../partials/Signature.vue';

export default {
  name: 'Home',

  components: {
    I18n,
    Signature,
  },

  data() {
    return {
      explain: false,
    };
  },
};
</script>
